'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './speaker-list.routes';

export class SpeakerListComponent {
  constructor(SpeakerService, dialogs, Auth, DTOptionsBuilder) {
    'ngInject';
    this.dialogs = dialogs;
    this.SpeakerService = SpeakerService;
    this.dataUpcoming = [];
    this.dataPast = [];

    this.userId = Auth.getCurrentUserSync()._id;
    this.isAdmin = Auth.isAdminSync;

    jQuery(document).ready(function() {
      jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "extract-date-pre": function (value) {
          return moment(value).toDate()
        },
        "extract-date-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },
        "extract-date-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('order', [0, 'desc'])
      .withOption('columnDefs', [{
        type: 'extract-date',
        targets: [0]
      }])
      .withOption('responsive', true)
      .withOption('hasBootstrap', true);

   this.getData();
  }

  getData() {
    let now = (new Date()).getTime();
    this.dataUpcoming = [];
    this.dataPast = [];

    this.SpeakerService.query(data => {

      data.forEach(speaker => {
        if (new Date(speaker.date).getTime() > now)
          this.dataUpcoming.push(speaker);
        else
          this.dataPast.push(speaker);
      })

    });
  }

  canEdit(speaker) {
    if (this.isAdmin())
      return true;
    
    if (speaker.meta.creationUser && speaker.meta.creationUser._id == this.userId)
      return true;

    return false;
  }

  delete(speaker) {
    var that = this;

    var speakerText = "<br/><br/><b>" + speaker.meta.creationUser.firstName + " " + speaker.meta.creationUser.lastName + " - " + speaker.meta.creationUser.companyName + "</b>";

    var dlg = this.dialogs.confirm("Delete Speaker?", "Do you really want to delete the Speaker?" + speakerText);
    dlg.result.then(() => {
      // OK delete it
      that.SpeakerService.delete({id: speaker._id},
        () => {
          that.getData();
        },
        err => {
          alert("Could not delete speaker");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.speakerList', [uiRouter])
  .config(routes)
  .component('speakerList', {
    template: require('./speaker-list.html'),
    controller: SpeakerListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/speaker/list/speaker-list.component.js